import React from 'react'

export const ValueContainer = props => <div className={props.selectProps.classes.valueContainer}>{props.children}</div>



// WEBPACK FOOTER //
// ./src/components/SelectAutocomplete/components/ValueContainer/index.js